<template>
	<div class="col" gutter="20">
		<Title title="管理通知" />
		<router-link :to="{name: 'newNotification'}">
			<el-button type="primary" icon="el-icon-plus" align-self="left" size="mini">新增通知</el-button>
		</router-link>
		<el-table :data="dataList" :default-sort="{prop: 'subject', order: 'descending'}">
			<el-table-column prop="subject" label="主旨" />
			<el-table-column prop="target" label="對象">
				<template slot-scope="{row}">{{mapTarget(row.target)}}</template>
			</el-table-column>
			<el-table-column prop="status" label="狀態">
				<template slot-scope="{row}">{{mapStatus(row.status)}}</template>
			</el-table-column>
			<el-table-column align="center">
				<template slot-scope="{row}">
					<div class="row" align-y="center" gutter="10">
						<router-link :to="{name: 'manageNotification', params:{id: row.id}}">檢視內容</router-link>
						<el-button @click="handleDelete(row.id)" class="color-danger" type="text" icon="el-icon-delete"></el-button>
					</div>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
import Title from "@/components/backendManage/Title";
import { mapActions, mapState } from "vuex";
import moment from "moment-timezone"

export default {
	components: { Title },
	data() {
		return {};
	},
	computed: {
		...mapState('notification', ['dataList', 'targetList', 'statusList']),
	},
	methods: {
		...mapActions('notification', ['getNotificationList', 'deleteNotification']),
		mapTarget(val) {
			return this.targetList.find(target => target.value == val).label;
		},
		mapStatus(val) {
			return this.statusList.find(target => target.value == val).label;
		},
		handleDelete(id) {
			this.$confirm('確定刪除？', '提示', {
				confirmButtonText: '確定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				await this.deleteNotification(id);
				this.$message({
					type: 'success',
					message: '刪除成功！'
				});
			}).catch(() => { });
		}
	},
	async created() {
		await this.getNotificationList();
	}
};
</script>

<style lang="scss" scoped>
</style>